import { Alert, Button, Form, Radio, Tooltip } from "antd";
import "./EditPatientInfo.css";
import { useContext, useEffect, useState } from "react";
import { SignedInContext } from "../AppEnv";
import { SignedInDoctor } from "../auth/interfaces";
import { emptyPatient, GenderType, Patient } from "./interfaces";
import EditPatientFormItems from "./EditPatientFormItems";
import { ALMSG_INTERNAL_ERR, ALMSG_TIMEOUT, PATIENTS_PATH } from "../env";
import { addPatient, editPatient } from "./utils";
import { Navigate, useNavigate } from "react-router-dom";
import DeletePatientModal from "./DeletePatientModal";
import TutorialButtonYouTube from "../exams/TutorialButtonYouTube";

const layout = {
  labelCol: { span: 0 },
  wrapperCol: { span: 24 },
};

export enum TABS {
  REQ,
  ADV,
  MED,
  FILE,
  ROD,
}

export enum PatientFormType {
  ADD,
  EDIT,
  protocolExample,
}

const PatientInfoEdit = ({
  basePatient,
  formType,
  setBasePatient,
}: {
  basePatient: Patient;
  formType: PatientFormType;
  setBasePatient?: Function;
}) => {
  const signedInDoctor: SignedInDoctor =
    useContext(SignedInContext).signedInDoctor;
  const [patient, setPatient] = useState(basePatient);
  const [editError, setEditError] = useState("");
  const [editSuccess, setEditSuccess] = useState("");
  const [selectedTab, setSelectedTab] = useState(TABS.REQ);
  const [form] = Form.useForm();
  const [compiledBase, setCompiledBase] = useState(false);


  
  
  const navigate = useNavigate();




  const submitPatient: Function =
  formType == PatientFormType.ADD ? addPatient : editPatient;
const btnConfirmText: string =
  formType == PatientFormType.ADD ? "AGGIUNGI" : "AGGIORNA";
const noReset: boolean = formType == PatientFormType.ADD ? false : true;

 //  console.log("formType:", formType);
//   console.log("btnConfirmText:", btnConfirmText); // Dovrebbe essere "AGGIUNGI" o "AGGIORNA"

 // console.log("PatientFormType.ADD:", PatientFormType.ADD);
 // console.log("PatientFormType.EDIT:", PatientFormType.EDIT);

  useEffect(() => {
    // console.log("p changed name=" + patient.name);
    //every time that patient changes, check validity of required fields
    const validName: boolean =
      patient.name != undefined && patient.name.length >= 2;
    const validSurname: boolean =
      patient.surname != undefined && patient.surname.length >= 2;
    const validGender: boolean =
      patient.gender != undefined &&
      [GenderType.M, GenderType.F, GenderType.O].filter(
        (e) => e == patient.gender
      ).length > 0;
    const validTelephone: boolean =
      patient.telephone != undefined && patient.telephone.length == 13;
    setCompiledBase(validName && validSurname && validGender && validTelephone);
  }, [patient, signedInDoctor]);

  useEffect(() => {
    if (editError != "") setTimeout(() => setEditError(""), ALMSG_TIMEOUT);
    if (editSuccess != "") setTimeout(() => setEditSuccess(""), ALMSG_TIMEOUT);
  }, [editError, editSuccess]);

  //submit data
  const onFinish = () => {
    submitPatient(signedInDoctor, patient)
      .then((patientOpString: string) => {
        try {
          const pId: number = parseInt(JSON.parse(patientOpString).id);
          if (!Number.isNaN(pId) && pId > 0) {
            if (formType == PatientFormType.ADD)
              navigate("/app" + PATIENTS_PATH + "/" + pId);
            else {
              if (setBasePatient != undefined) setBasePatient(patient);
              setEditError("");
              setEditSuccess("I dati del paziente sono stati aggiornati");
              console.log("Patient updated", patient );
            }
          } else setEditError(ALMSG_INTERNAL_ERR);
        } catch (err: any) {
          setEditError(patientOpString);
        }
      })
      .catch((err: any) => setEditError(ALMSG_INTERNAL_ERR));
  };

  //reset all fields
  const onReset = () => {
    form.resetFields();
    setPatient(emptyPatient);
  };


  return (
    <>
      <div style={{ margin: "auto", textAlign: "right" }}>
        <TutorialButtonYouTube
          video={
            "https://www.youtube.com/embed/UwmUHoJV-7Q?si=73CSVztlkxSLN7hj"
          }
          title={"Tutorial PhysiocheckApp | Creazione Nuovo Paziente"}
        />

        <Radio.Group
          onChange={(e) => setSelectedTab(e.target.value)}
          style={{ marginBottom: "32px" }}
          value={selectedTab}
        >
          <Radio.Button className="radio-button1" value={TABS.REQ}>
            Anagrafica base
          </Radio.Button>
          <Tooltip
            placement="top"
            title={!compiledBase ? "Compila Anagrafica base!" : ""}
          >
            <Radio.Button
              className="radio-button1"
              disabled={!compiledBase}
              value={TABS.ADV}
            >
              Anagrafica avanzata
            </Radio.Button>
          </Tooltip>
          <Tooltip
            placement="top"
            title={!compiledBase ? "Compila Anagrafica base!" : ""}
          >
            <Radio.Button
              className="radio-button1"
              disabled={!compiledBase}
              value={TABS.MED}
            >
              Profilo medico
            </Radio.Button>
            <Radio.Button
              className="radio-button1"
              disabled={!compiledBase}
              value={TABS.FILE}
            >
              Documenti
            </Radio.Button>
            <Radio.Button
              className="radio-button1"
              disabled={true}
              style={{ display: "none" }}
              value={TABS.ROD}
            >
              Protocollo
            </Radio.Button>
          </Tooltip>
        </Radio.Group>
      </div>

      <Form
        {...layout}
        form={form}
        name="control-hooks"
        initialValues={{ ...patient }}
        onFinish={onFinish}
        layout="vertical"
      >
        <EditPatientFormItems
          selectedTab={selectedTab}
          patient={patient}
          signedInDoctor={signedInDoctor}
          setPatient={setPatient}
        />
        <Form.Item style={{ margin: "auto", textAlign: "right" }}>
          <Tooltip
            placement="top"
            title={!compiledBase ? "Compila Anagrafica base!" : ""}
          >

         
            { (
             <Button
             className="ant-btn-ghost"
             type="dashed"
             htmlType="submit"
             disabled={!compiledBase}
             style={{
               background: "green",
               color: "white",
               margin: "2px",
             }}
           >
             {btnConfirmText}
           </Button>
            )}
            {formType == PatientFormType.EDIT && selectedTab != TABS.FILE && (
              <DeletePatientModal patient={patient} />
            )}
          </Tooltip>
          {!noReset && (
            <Button
              className="ant-btn-danger"
              htmlType="button"
              onClick={onReset}
              style={{ background: "black", color: "white", margin: "2px" }}
            >
              RESET
            </Button>
          )}
        </Form.Item>
        <Form.Item>
          {editError && (
            <Alert
              message="Operazione non riuscita"
              description={editError}
              type="error"
              showIcon
            />
          )}
          {!editError && editSuccess && (
            <Alert
              message="Operazione riuscita"
              description={editSuccess}
              type="success"
              showIcon
            />
          )}
        </Form.Item>
      </Form>
    </>
  );
};

export default PatientInfoEdit;
